import axios from 'axios';
import { JobDto, ApplicantDto, ApplicationStatus, JobBoardStats, CreateJobRequest, UpdateJobRequest } from '../types/jobBoard';
import { JOBBOARD_API_BASE_URL } from './apiConfig';

export const SERVER_URL = JOBBOARD_API_BASE_URL;
const API_BASE = `${JOBBOARD_API_BASE_URL}/api`;

const api = axios.create();

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const jobBoardApi = {
  // Jobs
  getJobs: () => api.get<JobDto[]>(`${API_BASE}/jobs`),
  getJob: (jobId: string) => api.get<JobDto>(`${API_BASE}/jobs/${jobId}`),
  createJob: (data: CreateJobRequest) => api.post<JobDto>(`${API_BASE}/jobs`, data),
  updateJob: (jobId: string, data: UpdateJobRequest) => api.put<JobDto>(`${API_BASE}/jobs/${jobId}`, data),
  deleteJob: (jobId: string) => api.delete(`${API_BASE}/jobs/${jobId}`),
  // Applicants
  getApplicantsByJob: (jobId: string) => api.get<ApplicantDto[]>(`${API_BASE}/applicants/job/${jobId}`),
  
  applyForJob: (formData: FormData) => api.post(`${API_BASE}/applicants/apply`, formData),

  updateApplicantStatus: (applicantId: string | number, status: ApplicationStatus) => api.post(`${API_BASE}/applicants/${applicantId}/status?status=${status}`),

  // Dashboard Statistics
  getOverviewStats: () => api.get<JobBoardStats>(`${API_BASE}/jobs/stats`), 
};